import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import Popup from '../../../common/Popup';
import * as irActions from '../../../../redux/actions/irSearch';
import DocketDetailsPurchaseForm from '../DocketDetailsPurchaseForm';


class DownloadCombineAllPdfInRangePopup extends Component {
  componentDidUpdate(prevProps) {
    if (!prevProps.docketParts.alreadyPurchased && this.props.docketParts.alreadyPurchased) {
      this.downloadPdfCombined();
    }
  }

  buy = () => {
    if (this.props.dispatch(irActions.checkClientCodeValid())) {
      this.props.dispatch(irActions.buyAllParts(this.props.popup.data)).then(() => this.downloadPdfCombined());
    } else {
      this.props.onClose();
    }
  }

  downloadPdfCombined = () => {
    this.props.dispatch(irActions.downloadPdfCombined(this.props.popup.data));
  }

  render() {
    const { popup, onClose, docketParts } = this.props;

    return (
      <Popup show={popup.show}
             clsName="docket-pdf-zip-popup"
             topBarTitle="Print Multiple Dockets"
             onClose={onClose}>
        <DocketDetailsPurchaseForm
          showXfaWarning
          docketParts={docketParts}
          buy={this.buy} />
      </Popup>
    );
  }
}

DownloadCombineAllPdfInRangePopup.propTypes = {
  onClose: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  docketParts: PropTypes.object.isRequired,
  popup: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
  const { popup, docketParts, favoriteEmail } = state.get('dockets').toJS();

  return {
    popup,
    docketParts,
    favoriteEmail,
  };
};

const mapDispatchToProps = dispatch => ({
  dispatch,
});

export default connect(mapStateToProps, mapDispatchToProps)(DownloadCombineAllPdfInRangePopup);



/** WEBPACK FOOTER **
 ** ./src/components/case/docket/popups/PrintAllPdfInRangePopup.jsx
 **/